//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features/index';
import { IUrlRouterProvider } from 'angular-ui-router';
import stubTrue from 'lodash/fp/stubTrue';

import {
  IPartialState,
  NavGroup,
  StateFactory,
  componentNameToTemplate,
  hasAllFeatures,
  lazyLoadModule,
} from 'app/initialization/routing/stateHelpers';

// Sets default values for state data
function FacebookStateFactory(state: IPartialState) {
  const accessFn = state.data?.hasAccess || stubTrue;
  const data = {
    title: 'Facebook',
    navGroup: NavGroup.PUBLISHING,
    ...state.data,
    hasAccess: () =>
      hasAllFeatures(FeatureNames.SocialDashboards) && accessFn(),
  };
  return StateFactory({
    ...state,
    data,
  });
}

export function routingRules(urlRouterProvider: IUrlRouterProvider) {
  urlRouterProvider.when('/facebook', '/facebook/summary');
  urlRouterProvider.when('/facebook/drafts', '/schedule/drafts');
  urlRouterProvider.when('/facebook/schedule', '/schedule/calendar');
}

export const states = {
  facebook: FacebookStateFactory({
    url: '/facebook',
    template: componentNameToTemplate('facebookPage'),
    resolve: {
      ...lazyLoadModule('curalate.facebook', () => import('./FacebookApp')),
    },
  }),

  'facebook.summary': FacebookStateFactory({
    url: '/summary',
    data: {
      title: 'Summary',
    },
  }),

  'facebook.audience': FacebookStateFactory({
    url: '/audience',
    data: {
      title: 'Audience',
    },
  }),

  'facebook.engagement': FacebookStateFactory({
    url: '/engagement',
    data: {
      title: 'Engagement',
    },
  }),
};
